import { visionChatCommands } from '../chat/vision-chat';

export class VisionCommandService {
  static async processCommand(message: string): Promise<string | null> {
    const msg = message.toLowerCase();

    // Comandos para status geral
    if (msg.includes('status das lojas') || 
        msg.includes('como estão as lojas') ||
        msg.includes('situação das lojas')) {
      return await visionChatCommands.getStatus();
    }

    // Comandos para buscar loja específica
    const searchStorePatterns = [
      /buscar loja (.+)/i,
      /como está a loja (.+)/i,
      /status da loja (.+)/i,
      /informações da loja (.+)/i
    ];

    for (const pattern of searchStorePatterns) {
      const match = msg.match(pattern);
      if (match) {
        return await visionChatCommands.getStore(match[1]);
      }
    }

    // Comandos para lojas atrasadas
    if (msg.includes('lojas atrasadas') || 
        msg.includes('atrasos') ||
        msg.includes('projetos atrasados')) {
      return await visionChatCommands.getOverdueStores();
    }

    // Comandos para próximos prazos
    if (msg.includes('próximos prazos') || 
        msg.includes('deadlines') ||
        msg.includes('prazos próximos') ||
        msg.includes('entregas próximas')) {
      return await visionChatCommands.getUpcomingDeadlines();
    }

    // Se não for um comando do Vision, retorna null
    return null;
  }
}
